<template>
  <div class="fast-search">
    <div
      class="fast-search__icon"
      @click="navigateToSearch"
    >
      <svg-loader src="/static/images/icon-tubes.svg" />
    </div>
    <div class="new-fast-search">
      <div class="new-fast-search__dropdown">
        <h6
          v-click-outside="outsideClicked"
          @click="isActiveDropdown = !isActiveDropdown"
        >
          {{ titleSearch }}
          <span
            :class="{ active: isActiveDropdown }"
            class="caret"
          />
        </h6>
        <ul v-if="isActiveDropdown">
          <li
            class="option"
            @click="selectValue(TRACEABILITY_SEARCH_OS_ALVARO)"
          >
            OS Alvaro
            <svg-loader
              v-if="type === TRACEABILITY_SEARCH_OS_ALVARO"
              src="/static/images/check-dropdown.svg"
            />
          </li>
          <li
            class="option"
            @click="selectValue(TRACEABILITY_SEARCH_PATIENT_NAME)"
          >
            Paciente
            <svg-loader
              v-if="type === TRACEABILITY_SEARCH_PATIENT_NAME"
              src="/static/images/check-dropdown.svg"
            />
          </li>
          <li
            class="option"
            @click="selectValue(TRACEABILITY_SEARCH_DATE)"
          >
            Data
            <svg-loader
              v-if="type === TRACEABILITY_SEARCH_DATE"
              src="/static/images/check-dropdown.svg"
            />
          </li>
          <li
            class="option"
            @click="selectValue(TRACEABILITY_SEARCH_SAMPLE)"
          >
            Amostra
            <svg-loader
              v-if="type === TRACEABILITY_SEARCH_SAMPLE"
              src="/static/images/check-dropdown.svg"
            />
          </li>
          <li
            class="option"
            @click="selectValue(TRACEABILITY_SEARCH_OS_LIS)"
          >
            OS Lis
            <svg-loader
              v-if="type === TRACEABILITY_SEARCH_OS_LIS"
              src="/static/images/check-dropdown.svg"
            />
          </li>
          <li
            class="option"
            @click="selectValue(TRACEABILITY_SEARCH_BATCH)"
          >
            Lote
            <svg-loader
              v-if="type === TRACEABILITY_SEARCH_BATCH"
              src="/static/images/check-dropdown.svg"
            />
          </li>
          <li
            class="option"
            @click="selectValue(TRACEABILITY_SEARCH_NTO)"
          >
            NTO
            <svg-loader
              v-if="type === TRACEABILITY_SEARCH_NTO"
              src="/static/images/check-dropdown.svg"
            />
          </li>
        </ul>
      </div>
      <div class="new-fast-search__field">
        <input
          v-if="
            type === TRACEABILITY_SEARCH_PATIENT_NAME ||
            type === TRACEABILITY_SEARCH_OS_ALVARO ||
            type === TRACEABILITY_SEARCH_SAMPLE ||
            type === TRACEABILITY_SEARCH_OS_LIS ||
            type === TRACEABILITY_SEARCH_BATCH ||
            type === TRACEABILITY_SEARCH_NTO
          "
          v-model="query"
          v-validate="validateValueType(type)"
          :placeholder="placeholderType"
          data-vv-validate-on="change|blur"
          maxlength="199"
          :name="type"
          @keydown.enter="search()"
        />

        <date-picker-range
          v-if="type === TRACEABILITY_SEARCH_DATE"
          :date-selected.sync="date"
          :date-filter-alternative="true"
          :limit-data="limitDateForTraceability"
          :calendar-direction="'top'"
          :clear-button="false"
          :default-start-date="sevenDaysAgo"
          :default-end-date="today"
        />

        <div
          class="new-fast-search__btn btn-primary btn-container"
          @click="search()"
        >
          <md-tooltip>Buscar</md-tooltip>
          <svg-loader src="/static/images/icon-search-small.svg" />
        </div>
      </div>
    </div>

    <span
      v-if="
        errors.firstByRule(
          'OA',
          'numeric' ||
            errors.firstByRule('AM', 'numeric') ||
            errors.firstByRule('OL', 'numeric')
        )
      "
      class="error"
    >
      Insira apenas números, sem espaços.
    </span>
    <span
      v-if="errors.firstByRule('PN', 'alpha_spaces')"
      class="error"
    >
      Insira apenas letras e espaços.
    </span>
    <span
      v-if="
        errors.firstByRule('OA', 'required') ||
        errors.firstByRule('PN', 'required') ||
        errors.firstByRule('AM', 'required') ||
        errors.firstByRule('OL', 'required') ||
        errors.firstByRule('BA', 'required') ||
        errors.firstByRule('NTO', 'required')
      "
      class="error"
    >
      Digite algo para pesquisar.
    </span>
  </div>
</template>

<script>
import notify from '@/api/notification'
import DatePickerRange from '@/components/common/DatePickerRange'
import Moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import {
  TRACEABILITY_SEARCH_PATIENT_NAME,
  TRACEABILITY_SEARCH_OS_ALVARO,
  TRACEABILITY_SEARCH_DATE,
  TRACEABILITY_SEARCH_SAMPLE,
  TRACEABILITY_SEARCH_OS_LIS,
  TRACEABILITY_SEARCH_BATCH,
  TRACEABILITY_SEARCH_NTO,
} from '@/enums'
import strings from '@/strings'
import { clickOutside } from '@/utils/directives'

export default {
  name: 'FastSearch',
  components: {
    'date-picker-range': DatePickerRange,
  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
      },
    },
    clickOutside,
  },
  data() {
    return {
      type: TRACEABILITY_SEARCH_DATE,
      query: '',
      date: {
        start: Moment().subtract(7, 'days').toDate(),
        end: new Date(),
      },
      isActiveDropdown: false,
      limitDaysTraceability: strings.limitDaysForCalendar.traceability,
      TRACEABILITY_SEARCH_OS_ALVARO: TRACEABILITY_SEARCH_OS_ALVARO,
      TRACEABILITY_SEARCH_PATIENT_NAME: TRACEABILITY_SEARCH_PATIENT_NAME,
      TRACEABILITY_SEARCH_DATE: TRACEABILITY_SEARCH_DATE,
      TRACEABILITY_SEARCH_SAMPLE: TRACEABILITY_SEARCH_SAMPLE,
      TRACEABILITY_SEARCH_OS_LIS: TRACEABILITY_SEARCH_OS_LIS,
      TRACEABILITY_SEARCH_BATCH: TRACEABILITY_SEARCH_BATCH,
      TRACEABILITY_SEARCH_NTO: TRACEABILITY_SEARCH_NTO,
    }
  },
  computed: {
    ...mapGetters(['profile']),
    placeholderType: function () {
      switch (this.type) {
        case TRACEABILITY_SEARCH_PATIENT_NAME:
          return 'Nome do paciente'
        case TRACEABILITY_SEARCH_OS_ALVARO:
          return 'Número da OS Alvaro'
        case TRACEABILITY_SEARCH_SAMPLE:
          return 'Número da amostra'
        case TRACEABILITY_SEARCH_OS_LIS:
          return 'Número OS Lis'
        case TRACEABILITY_SEARCH_BATCH:
          return 'Número do Lote'
        case TRACEABILITY_SEARCH_NTO:
          return 'Nome do NTO'
        default:
          break
      }
    },
    titleSearch() {
      switch (this.type) {
        case TRACEABILITY_SEARCH_PATIENT_NAME:
          return 'Paciente'
        case TRACEABILITY_SEARCH_OS_ALVARO:
          return 'OS Alvaro'
        case TRACEABILITY_SEARCH_SAMPLE:
          return 'Amostra'
        case TRACEABILITY_SEARCH_DATE:
          return 'Data'
        case TRACEABILITY_SEARCH_OS_LIS:
          return 'OS Lis'
        case TRACEABILITY_SEARCH_BATCH:
          return 'Lote'
        case TRACEABILITY_SEARCH_NTO:
          return 'NTO'
        default:
          break
      }
    },
    today() {
      return Moment(new Date()).format('DD/MM/YYYY')
    },
    sevenDaysAgo() {
      return Moment().subtract(7, 'days').format('DD/MM/YYYY')
    },
    limitDateForTraceability() {
      return Moment(new Date()).subtract(this.limitDaysTraceability, 'days').toDate()
    },
  },
  methods: {
    ...mapActions(['resetTraceabilityStore']),
    navigateToSearch() {
      this.$router.push({
        path: 'traceability/search',
        query: {
          typeOfSearch: TRACEABILITY_SEARCH_DATE,
          startDate: Moment(new Date()).clone().subtract(7, 'days').format('DD/MM/YYYY'),
          endDate: Moment(new Date()).format('DD/MM/YYYY'),
        },
      })
    },
    search() {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.type === TRACEABILITY_SEARCH_DATE) {
            this.$router.push({
              path: 'traceability/search',
              query: {
                startDate: Moment(this.date.start).format('DD/MM/YYYY'),
                endDate: Moment(this.date.end).format('DD/MM/YYYY'),
                typeOfSearch: this.type,
              },
            })
          } else {
            this.$router.push({
              path: 'traceability/search',
              query: { q: this.query, typeOfSearch: this.type },
            })
          }

          this.$analytics.pushAnalyticsEvent('ga-event', {
            category: 'Rastreabilidade',
            action: 'Busca via Dashboard por ' + this.type,
            'id-user': this.profile.id,
            'id-lab': this.profile.id_laboratory,
            'name-lab': this.profile.laboratoryName,
          })
          return
        } else {
          notify({
            title: 'AVISO:',
            message: 'Verifique o campo de busca.',
          })
        }
      })
    },
    validateValueType(type) {
      if (type === 'OA' || type === 'AM') {
        return 'required|numeric'
      } else if (type === 'BA' || type === 'OL' || type === 'NTO') {
        return 'required'
      } else {
        return 'required|alpha_spaces'
      }
    },
    selectValue(selected) {
      this.isActiveDropdown = false
      this.type = selected
    },
    outsideClicked() {
      this.isActiveDropdown = false
    },
  },
}
</script>
<style lang="scss">
.fast-search {
  display: flex;
  justify-items: center;
  flex-wrap: wrap;
  margin-top: 0.5em;
  padding-bottom: 25px;

  &__header {
    width: 100%;
    display: flex;
    flex-wrap: nowrap;

    h1 {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 26px;
      color: #4a4a4a;
    }

    h2 {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 26px;
      color: #7a7a7a;
    }

    .md-radio {
      margin: 0 14px 10px 0;
    }

    .md-radio-label {
      font-family: Roboto, sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      letter-spacing: 0.8px;
      color: #7a7a7a;
    }

    .md-theme-default.md-radio.md-checked .md-radio-container {
      border-color: #d9d9d9;
    }

    .md-theme-default.md-radio .md-radio-container::after {
      background-color: #7f1a54;
    }

    .md-radio.md-checked .md-radio-container::after {
      transform: scale3D(1.5, 1.5, 1.5);
    }
    .md-radio .md-radio-container {
      border: 2px solid #d9d9d9;
    }
  }

  &__icon {
    position: absolute;
    right: 17px;
    top: 15px;
    cursor: pointer;

    .md-icon {
      width: 25px;
      height: 25px;

      & > svg {
        .main-tube {
          stroke: #7f1a54;
          stroke-width: 3;
        }
        .bubbles {
          stroke: #7f1a54;
          stroke-width: 1;
        }
        .shawdow-tube {
          stroke: #cda3bb;
          stroke-width: 3;
        }
      }
    }
  }

  &__field {
    width: 100%;
    display: flex;
    cursor: pointer;

    .btn-container {
      width: 2.5em;
      cursor: pointer;
      display: flex;

      .md-icon {
        align-self: center;
        min-width: 16px;
        height: 16px;
        min-height: 16px;
        width: 16px;
      }
    }
  }
  .error {
    font-family: Roboto, sans-serif;
    font-size: 13px;
    color: #d71d33;
  }

  .new-fast-search {
    display: flex;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%;
    flex-wrap: nowrap;
    justify-content: space-between;
    min-height: 40px;
    align-items: center;

    h6 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100px;
      padding: 8px;
      font-weight: 500;
      font-size: 13px;
      color: #999;
      cursor: pointer;

      .caret {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #7f1a54;
        border-radius: 6px;
        transform: rotate(180deg);
        transition: all ease-out 0.3s;

        &.active {
          transform: rotate(0deg);
        }
      }
    }

    &__dropdown {
      border-right: 1px solid #ccc;
      position: relative;

      ul {
        width: 142px;
        display: flex;
        flex-wrap: wrap;
        padding: 8px;
        background: #ffffff;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        position: absolute;
        left: 0;
        top: 44px;
      }

      li {
        width: 100%;
        padding: 9px;
        margin: 0;
        font-size: 14px;
        color: #363636;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #ffffff;
        transition: all ease 0.3s;
        cursor: pointer;

        &:hover {
          background-color: #e9e9e9;
          border-radius: 4px;
        }

        i {
          margin: 0;
        }
      }
    }

    &__field {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-grow: 1;
      flex-shrink: 1;

      input {
        font-weight: 500;
        font-size: 13px;
        line-height: 16px;
        color: #999999;
        height: 40px;
        padding: 0 8px;
        border: none;
        flex-grow: 1;
        outline: none;
      }
    }

    &__btn {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0px 4px 4px 0px;
      width: 40px;
      height: 40px;
      cursor: pointer;

      .md-icon {
        width: 15px;
        min-width: 15px;
        height: 15px;
        min-height: 15px;
      }

      svg {
        path {
          fill: white;
        }
      }
    }

    .date-range-container {
      flex: 1;

      .search-bar__date {
        border: 2px solid #d8d8d8;
        border-right: none;
        height: 2.5em;
      }

      &-label {
        color: #7a7a7a;
        text-align: left;
        font-size: 12px;
        font-weight: 500;
        padding-top: 5px;
        padding-right: 10px;
        letter-spacing: 1px;
        text-transform: uppercase;
      }

      .search-bar__date {
        margin: 0;
      }

      .md-input-container {
        border-right: 2px solid #d8d8d8;
        padding: 0 5px;
        min-height: 0;
        margin: 0;

        .md-input {
          padding-left: 10px;
        }
      }
    }
    // Workaround to make calendar popover ignores parent overflow hidden from card
    .popover-content-wrapper {
      position: fixed !important;
    }

    .search-bar__date {
      margin: 0;
    }

    .alternative .md-input-container {
      margin: 0;
      padding: 0;
      height: 40px;
      min-height: inherit !important;

      input {
        font-weight: 500;
        font-size: 13px;
      }

      i {
        margin: 8px;
      }
    }
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  // IE10 & IE11 CSS styles go here
  // Workaround to make calendar popover ignores parent overflow hidden from card on IE
  #traceability-search.md-card {
    overflow: visible;
  }
}
</style>
